import {
     UPLOAD_FILE_REQUEST,
     UPLOAD_FILE_FAILURE,
     UPLOAD_FILE_SUCCESS,
     PROFILE_PICTURE_INSURANCE_ID_SUCCESS,
     PROFILE_PICTURE_INSURANCE_ID_REQUEST,
     PROFILE_PICTURE_INSURANCE_ID_FAILURE
} from "constants/UploadFile"


const initialState = {
     message: "",
     loading: false,
     errorMessage: ""
}

const UploadFile = (state = initialState, action) => {
     switch (action.type) {
          case UPLOAD_FILE_REQUEST:
               return {
                    loading: true
               }
          case UPLOAD_FILE_SUCCESS:
               return {
                    loading: false,
                    message: action.paylaod
               }
          case UPLOAD_FILE_FAILURE:
               return {
                    loading: false,
                    errorMessage: action.paylaod
               }

          case PROFILE_PICTURE_INSURANCE_ID_REQUEST:
               return {
                    loading: true
               }
          case PROFILE_PICTURE_INSURANCE_ID_SUCCESS:
               console.log('PROFILE_PICTURE_INSURANCE_ID_SUCCESS payload:', action.payload); // 👈 Add this
               return {
                    loading: false,
                    message: action.payload
               }
          case PROFILE_PICTURE_INSURANCE_ID_FAILURE:
               return {
                    loading: false,
                    errorMessage: action.paylaod
               }
          default:
               return state;
     }
}
export default UploadFile;